/**
 * ローディングアイコンを表示するエレメントを返します
 * @returns {HTMLDivElement}
 */
export const createLoadingElement = () => {
  const elem = document.createElement("div")
  elem.className = "loader"

  return elem
}